import { createSlice } from "@reduxjs/toolkit";

export const farm_name_and_ownership = createSlice({
  name: "farm_name_and_ownership",
  initialState: {
    value: {
      status: false,
      data: {
        farmname: "",
        ownershipStatus: "Farm owner",
        ownershipStatusOther: "",
      },
    },
  },
  reducers: {
    updateFarmNameAndOwnership: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateFarmNameAndOwnership } = farm_name_and_ownership.actions;

export default farm_name_and_ownership.reducer;
